import { render } from "./Home.vue?vue&type=template&id=613b1010&scoped=true&lang=pug"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=613b1010&scoped=true&lang=scss"

import exportComponent from "/Users/adolforeyna/Projects/EMI/website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-613b1010"]])

export default __exports__